import { AdminListing } from "./AdminListing";

export class AdminListingResponse{
    public adminListingsList: AdminListing[] = [];
}